<ng-container [ngTemplateOutlet]="currentView()"></ng-container>

<ng-template viewMode>
    @if (editAllowed()) {
        <fa-icon (click)="switchMode('edit')" [icon]="icons.faEdit" class="text-secondary me-2"></fa-icon>
    }
    <span *ngIf="inputType() === 'date'">
        {{ editValue() | date: 'dd/MM/yy'}}
    </span>
    <span *ngIf="inputType() === 'string'">
        {{ editValue() }}
    </span>
    <span *ngIf="inputType() === 'number' && !isCurrency()">
        {{ editValue() | number: '1.2-2' }}
    </span>
    <span *ngIf="inputType() === 'number' && isCurrency()">
        {{ editValue() | currency: 'USD' }}
    </span>
</ng-template>

<ng-template editMode>
    <div class="d-flex align-items-center">
        <input decimalLimitInput [inputType]="inputType()" class="form-control form-control-sm me-2" style="width: 100px; font-size: 0.8em;" [type]="inputType()"
            [(ngModel)]="value">
        
        <button (click)="save()" class="btn btn-sm btn-success me-1" title="Guardar">
            <fa-icon [icon]="icons.faCircleCheck" size="xs"></fa-icon>
        </button>
        <button (click)="onCancel()" class="btn btn-sm btn-secondary" title="Cancelar">
            <fa-icon [icon]="icons.faTimes" size="xs"></fa-icon>
        </button>
    </div>
</ng-template>